/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Is_Community_PrivateInputs */

const en_is_community_private = /** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Discussion (Requires Approval)`)
};

const es_is_community_private = /** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discusión Privada (Requiere Aprobación)`)
};

const fr_is_community_private = /** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion privée (Nécessite une approbation)`)
};

const de_is_community_private = /** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Diskussion (Erfordert Genehmigung)`)
};

const id_is_community_private = /** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskusi Pribadi (Membutuhkan Persetujuan)`)
};

/** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */
const ja_is_community_private = en_is_community_private;

/** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */
const zh_is_community_private = en_is_community_private;

/** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */
const ar_is_community_private = en_is_community_private;

/** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */
const it_is_community_private = en_is_community_private;

/** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */
const ru_is_community_private = en_is_community_private;

/** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */
const pt_is_community_private = en_is_community_private;

/** @type {(inputs: Is_Community_PrivateInputs) => LocalizedString} */
const ko_is_community_private = en_is_community_private;

/**
* | output |
* | --- |
* | "Private Discussion (Requires Approval)" |
*
* @param {Is_Community_PrivateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const is_community_private = /** @type {((inputs?: Is_Community_PrivateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Is_Community_PrivateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_is_community_private(inputs)
	if (locale === "es") return es_is_community_private(inputs)
	if (locale === "fr") return fr_is_community_private(inputs)
	if (locale === "de") return de_is_community_private(inputs)
	if (locale === "ja") return ja_is_community_private(inputs)
	if (locale === "zh") return zh_is_community_private(inputs)
	if (locale === "ar") return ar_is_community_private(inputs)
	if (locale === "id") return id_is_community_private(inputs)
	if (locale === "it") return it_is_community_private(inputs)
	if (locale === "ru") return ru_is_community_private(inputs)
	if (locale === "pt") return pt_is_community_private(inputs)
	return ko_is_community_private(inputs)
});